module.exports = __webpack_public_path__ + "static/media/Expansion of dental arches1.b9c29e0e.png";